module.exports = __webpack_public_path__ + "img/多多_亮.e5f0c10e.png";